import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoutesOutlet from "./_routes/ProtectedRotuesOutlet";
import ProtectedRotues from "./_routes/ProtectedRoutes";
import { Toaster } from "react-hot-toast";
import PublicRoutes from "./_routes/PublicRoutes";
import PublicRoutesOutlet from "./_routes/PublicRotuesOutlet";
import { useEffect, useState } from "react";
import Notification from "./_pages/Notification";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./_components/common/Loader";
import Terms from "./_components/Tc/Terms";
import { setUserInformation } from "./_store/reducers/userReducer";





function App() {
  const dispatch = useDispatch();
  const value = useSelector((state) => state.notification.showNotifications);

   //fetch plan from query params if present
   const queryParams = new URLSearchParams(window.location.search);
   const planName= queryParams.get('plan-name');
   if (planName) {
     dispatch(setUserInformation("User", "123", "user@example.com", 0, planName));
   }






  return (
    <div className="main">
      { value && <Notification />}
      {<Loader />}
      <Toaster
        position="top-right"
        containerClassName="hot-toaster-container"
      />
     
      <Routes>
        <Route element={<ProtectedRoutesOutlet />}>
          {ProtectedRotues?.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Route>
        <Route element={<PublicRoutesOutlet />}>
          {PublicRoutes?.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={route.element}
            />
          ))}
       
        </Route>
        <Route path="*" element={<Navigate to="/login" />} />
        <Route path="/terms-and-conditions" element={<Terms />} />
      </Routes>
    </div>
  );
}

export default App;
